

Acr = window.Acr || {};

Acr.SignUpForEmails = (function (window, $) {
  var DeepLink;
  var $context = $('.acr-sign-up-form-emails');
  var contextId = $context.attr('id');
  var sectionPadding = -40;
  var trackingSubmitObject = {
    'Event Metadata': {
      action_category: 'mlp newsletter',
      action_type: 'cta',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:newsletter:submit',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
    ],
  };

  var $form = $('form', $context);

  var attachEvents = function () {
    var regExp = /[a-z]/i;

    $form.on('submit', onSubmit);

    $('input', $form)
      .on('keypress', Validation.onKeypress)
      .on('keyup', Validation.onKeyup)
      .on('focus', Validation.onFocus)
      .on('blur', Validation.onBlur);

    $('[name="PhoneNumber"]', $form)
      .on('keyup', function () {
      // Phone number key up (format phone number)
        var $this = $(this);
        $this.val(Utility.formatPhone($this.val()));
      })
      .on('keydown', function (e) {
      // Phone number key down (no alpha characters allowed)
        var value = String.fromCharCode(e.which) || e.key;

        // No letters
        if (regExp.test(value)) {
          e.preventDefault();
          return false;
        }
      });

    $('.acr-show-form', $context).on('click', showForm);
  };

  var onSubmit = function (e) {
    var success = Validation.validateForm(e);
    Utility.log('onSubmit submission', e);
    if (success) {
      sendSuccessTrackingObject(false);
      send(e.target);
    }

    e.preventDefault();
    return false;
  };

  var send = function (form) {
    var data = Acr.CampaignManager.appendCampaignName($(form).serialize());
    var method = form.getAttribute('method');
    var action = form.getAttribute('action');

    $.ajax({
      beforeSend: function () {
        $('.acr-sign-up-form-emails-content', $context).addClass('acr-hidden');
        $('.acr-sign-up-form-emails-processing', $context)
          .css('display', 'block');

        DeepLink.inPageDeepLink(contextId, sectionPadding);
      },
      data: data,
      error: function (jqXHR, textStatus, errorThrown) {
        console.log('error', jqXHR, textStatus, errorThrown);
      },
      method: method,
      success: function (data) {
        if (data.Status === 'success') {
          sendSuccessTrackingObject(true);
        }
        var message = $('<div>').html(data.Message).text();

        $('.acr-sign-up-form-emails-processing', $context)
          .css('display', 'none');
        $('.acr-sign-up-form-emails-message', $context).html(message);
        $('.acr-sign-up-form-emails-response', $context)
          .css('display', 'block');

        DeepLink.inPageDeepLink(contextId, sectionPadding);
      },
      url: action,
    });
  };
  var sendSuccessTrackingObject = function (isSuccess) {
    var object = JSON.parse(JSON.stringify(trackingSubmitObject));
    if (isSuccess) {
      object.dynamic_variables[0].search += ' success';
    }
    if (Acr.TrackingManager) {
      Acr.TrackingManager.clickActivity(object);
    }
  };
  var showForm = function () {
    $('.acr-sign-up-form-emails-messges', $context).css('display', 'none');

    $('.acr-sign-up-form-emails-content', $context).removeClass('acr-hidden');

    $('input', $form).removeClass('acr-not-empty');

    $('form', $context)[0].reset();

    DeepLink.inPageDeepLink(contextId, sectionPadding);
  };

  var init = function () {
    DeepLink = window.Acr ? window.Acr.DeepLinking || {} : {};

    attachEvents();
  };

  return {
    init: init,
  };
}(window, window.$));

